import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IReportDrilling } from '../../../interfaces/report-drilling';

@Component({
  selector: 'app-total-depth',
  templateUrl: './total-depth.component.html',
  styleUrls: ['./total-depth.component.scss'],
})
export class TotalDepthComponent implements OnInit {
  @Input()
  public set reportData(value: IReportDrilling[]) {
    this.createTable(value);
  }

  public hasData: boolean;
  public totalDepth: number;
  public quantityDepth: number;
  public message: string;

  constructor(private langService: LanguageService) {
    this.message = '';
  }

  ngOnInit() {}

  /**
   * start create table
   */
  private createTable(data: IReportDrilling[]): void {
    if (data && data.length) {
      this.totalDepth = data[0].totalDepth;
      this.quantityDepth = data[0].totalCountDisplacementNumber;
      this.hasData = true;
    } else {
      this.message = this.langService.message('m034');
    }
  }
}
